import { BuildInAppToolId } from '../types/appTools';
import { IntegrationPointType } from '../../extensions/types/appExtension';
import CollaborationToolEnabled from '../toolsEnabled/CollaborationToolEnabled';
import AdaChatToolEnabled from '../toolsEnabled/AdaChatToolEnabled';
import DefaultToolEnabled from '../toolsEnabled/DefaultToolEnabled';
import MeetingsToolEnabled from '../toolsEnabled/MeetingsToolEnabled';
import EngagementAppEnabled from '../toolsEnabled/EngagementAppEnabled';

const AppToolbarItemEnabled = {
    [BuildInAppToolId.SessionChats]: CollaborationToolEnabled,
    [BuildInAppToolId.SupportChat]: AdaChatToolEnabled,
    [BuildInAppToolId.Meetings]: MeetingsToolEnabled,
    [IntegrationPointType.VENUE_SESSION_SIDE_PANEL]: EngagementAppEnabled,
};

export const getItemEnabled = appToolType =>
    AppToolbarItemEnabled[appToolType] ?? DefaultToolEnabled;
